<header class="header">
  <div class="container-core">
    <div class="header-title">
      <div class="header__icon"></div>
      <div class="header__icon__additional"></div>
    </div>
  </div>
</header>
